<template>
    <main-layout>
        <!--<p>NUM OTAG : {{ otag }}</p>-->
    </main-layout>
</template>

<script>
import Bouteille from "../../js/models/Bouteille"
import localforage from "localforage";

export default {
    data(){
        return {

        }
    },
    computed: {
        otag(){
            return this.$route.params.str
        }
    },
    async beforeCreate(){

        let str = this.$route.params.str;
        let addBouteille = null
        if(typeof this.$route.params.bouteille != "undefined") {
            addBouteille = this.$route.params.bouteille;
        }
        let strValid = true;
        let tab = [];

        if( !_.includes(str, '-')){
            strValid = false
        } else {
            tab = str.split('-');
            if(tab.length !== 2){
                strValid = false
            }

            //Si premier otag plus grand que 2 chiffre xx-xxxxx
            if(tab[0].length > 2){
                strValid = false
            }

            if(isNaN(tab[0]) || isNaN(tab[1])){
                strValid = false
            }

        }

        if(strValid) {
            const _rawOtags = JSON.parse(await localforage.getItem('OTAGS'));
            let otags = Array.isArray(_rawOtags) ? _rawOtags : [];

            if(otags.indexOf(tab[0]+'-'+tab[1]) !== -1){

                const goHome = () => this.$router.push({name:'home'});
                swal('OTAG utilisé', "Cette puce OTAG ("+tab[0]+'-'+tab[1]+") a déjà été utilisée.", 'error').then(goHome, goHome)

            } else {

                let router = this.$router;



                Bouteille
                    .getBouteilleByTag( parseInt(tab[0]), tab[1] )
                    .then(bouteille => {
                        //Bouteille existante
                        this.$router.push({ name: 'bouteille', params: {id: bouteille.id}, query: {scan: true} })
                    })
                    .catch(() => {
                        //Bouteille inexistante

                        if(addBouteille != null) {
                            Bouteille.getBouteille(addBouteille)
                                .then(async bouteille => {
                                    if(bouteille.key1 === null && bouteille.key2 === null && bouteille.otag === null) {

                                        bouteille.key1 = tab[0];
                                        bouteille.key2 = tab[1];
                                        bouteille.otag = tab[0] + '-' + tab[1];
                                        await Bouteille.updateBouteille(bouteille.id, bouteille).then(
                                            function () {
                                                router.push({ name: 'bouteille', params: {id: bouteille.id}, query: {scan: true, addOtag: true} })
                                            },
                                            () => {
                                                const goBouteille = () => router.push({ name: 'bouteille', params: {id: bouteille.id} });
                                                swal('Erreur', 'Une erreur est survenue lors de la modification de la bouteille', 'error').then(goBouteille, goBouteille)
                                            }
                                        )
                                    }else{
                                        const goBouteille = () => router.push({ name: 'bouteille', params: {id: bouteille.id} });
                                        swal('Erreur', 'Cette bouteille a déjà une otag', 'error').then(goBouteille, goBouteille)
                                    }

                                })
                                .catch(() => {
                                    const goListe = () => router.push({ name: 'liste-bouteilles' });
                                    swal('Erreur', 'Bouteille introuvable', 'error').then(goListe, goListe)
                                })
                            //router.push({ name: 'bouteille', params:{id: addBouteille}, query: {key1:tab[0], key2: tab[1], scan: true} });
                            return;
                        }

                        let type = null;
                        let html = "";

                        html += '<a class="btn addbouteille" onclick="swal.clickConfirm()" href="#" id="btFf" >Fluide Frigorigène</a>';

                        html += '<a class="btn addbouteille" onclick="swal.clickConfirm()" href="#" id="btR">Récupération</a>';

                        html += '<a class="btn addbouteille" onclick="swal.clickConfirm()" href="#" id="btT">Transfert</a>';

                        const goListe = () => router.push({ name: 'liste-bouteilles' });

                        swal({
                            title: 'Type bouteille',
                            showConfirmButton: false,
                            showCloseButton: true,
                            allowOutsideClick: false,
                            html
                        }).then(() => {}, goListe)

                        function goToRoute(tab, type, others) {
                            let location = null;
                            if(typeof others !== 'undefined'){
                                if(typeof others.code !== 'undefined'){
                                    location = { name: 'new-bouteille', query: {key1:tab[0], key2: tab[1], scan: true, type: type, wantScan: others.wantScan, code: others.code } };
                                }else{
                                    location = { name: 'new-bouteille', query: {key1:tab[0], key2: tab[1], scan: true, type: type, wantScan: others.wantScan} };
                                }
                            }else{
                                location = { name: 'new-bouteille', query: {key1:tab[0], key2: tab[1], scan: true, type: type} };
                            }
                            router.push(location);
                        }

                        let btFf = document.getElementById('btFf');
                        let btR = document.getElementById('btR');
                        let btT = document.getElementById('btT');

                        btFf.onclick = function () {
                            swal.clickConfirm();
                            type = 'Fluide frigorigène'
                            goToRoute(tab, type);
                        }

                        function displayCodeBouteille(tab, type) {
                            html = '<a class="btn btn-full" style="margin-bottom: 15px; font-size: 1.4rem; text-align: center; align-items: center" id="scanCodeBarre">SCAN CODE BARRE</a>'
                            html += '<input title="code" id="codeBt" placeholder="Code bouteille" type="text" maxLength="255"><br>';
                            html += '<button class="btn btn-full" id="validFromCodeBouteille">Valider</button>'

                            swal({
                                title: 'Saisissez le numéro bouteille ou scanner le code barre',
                                showConfirmButton: false,
                                showCloseButton: true,
                                allowOutsideClick: false,
                                html
                            }).then(() => {}, goListe)

                            let btScanCodeBarre = document.getElementById('scanCodeBarre');
                            let btnValidFromCodeBouteille = document.getElementById('validFromCodeBouteille');

                            btScanCodeBarre.onclick = function () {
                                swal.clickConfirm();
                                goToRoute(tab, type, { wantScan: true });
                            }

                            btnValidFromCodeBouteille.onclick = function () {
                                swal.clickConfirm();
                                //console.log(document.getElementById('codeBt').value)
                                goToRoute(tab, type, { code: document.getElementById('codeBt').value });
                            }


                        }

                        btR.onclick = function () {
                            swal.clickConfirm();
                            type = 'Récupération'


                            displayCodeBouteille(tab, type);


                        }

                        btT.onclick = function () {
                            swal.clickConfirm();
                            type = 'Transfert'


                            displayCodeBouteille(tab, type);

                        }



                    })
            }

        } else {
            let router = this.$router;
            const goListe = () => router.push({name:'liste-bouteilles'});
            swal('Tag invalide', "Ce tag NFC n'est pas un scan OTAG", 'error').then(goListe, goListe)
        }
    }
}
</script>




// WEBPACK FOOTER //
// ScanOtag.vue?0fa183f5